import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bengaliNumber',
})
export class BengaliNumberPipe implements PipeTransform {
  transform(value: number): string {
    const banglaNumbers = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
    return value.toString().replace(/\d/g, (digit) => banglaNumbers[+digit]);
  }
}
